var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('use',{attrs:{"xlink:href":_vm.path}})}
var staticRenderFns = []

export { render, staticRenderFns }